import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import Feather from "@expo/vector-icons/Feather";
import { ODSIcon } from "../../atoms/ODSIcon";
import moment from "moment";

const TenantCard = ({ item, index, onUnlink }) => {
  const { user, opbrix_id } = item;
  const isRegistered = user?.is_registered;
  const fullName =
    user?.first_name || user?.last_name
      ? `${user?.first_name || ""} ${user?.last_name || ""}`.trim()
      : null;
  return (
    <View style={styles.card}>
      <Text style={styles.title}>Joint tenant {index + 1}</Text>
      <Text style={styles.name}>
        {fullName || user?.email}
      </Text>
      <Text style={styles.sub}>tlyfe ID: {opbrix_id}</Text>
      {isRegistered && (
        <View style={styles.statusRow}>

            <ODSIcon color={"#5CC489"} icon={"TB-Check-Circle"} size={28} /> 

          <Text style={styles.connected}> Connected</Text>
        </View>
      )}
      {isRegistered && (
        <TouchableOpacity style={styles.unlinkBtn} onPress={() => onUnlink(item)}>
          <Text style={styles.unlinkText}>Unlink</Text>
        </TouchableOpacity>
      )}
      {isRegistered ? (
        <Text style={styles.desc}>
          <Text style={styles.boldItalic}>
            You added {fullName || "{name}"} / {fullName || "{name}"} added you
          </Text>{" "}
          as joint tenant on {moment((item?.AppUserGroupMember?.createdAt)).format('DD/MM/YYYY')}. Click this button to remove the
          connection
        </Text>
      ) : (
        <Text style={styles.desc}>
          You invited <Text style={styles.bold}>{user?.email}</Text> to join this
          tenancy. We’ll let you know once it’s accepted
        </Text>
      )}
    </View>
  );
};

export default TenantCard;

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#F5F6F7",
    padding: 18,
    borderRadius: 8,
    marginBottom: 16,
  },

  title: {
    fontSize: 22,
    fontWeight: "800",
    color: "#333",
    marginBottom: 10,
  },

  name: {
    fontSize: 16,
    fontWeight: "500",
    color: "#2C2C2C",
  },

  sub: {
    fontSize: 16,
    color: "#555",
    marginTop: 4,
    marginBottom: 14,
  },

  statusRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 14,
  },

  checkCircle: {
    width: 26,
    height: 26,
    borderRadius: 13,
    backgroundColor: "#5CC489",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 10,
  },

  connected: {
    fontSize: 18,
    color: "#333",
  },

  unlinkBtn: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 2,
    borderColor: "#E74C3C",
    borderRadius: 30,
    paddingVertical: 8,
    paddingHorizontal: 16,
    alignSelf: "flex-start",
    marginBottom: 16,
  },

  unlinkText: {
    color: "#2C2C2C",
    fontSize: 18,
    fontWeight: "600",
    marginLeft: 10,
  },

  desc: {
    fontSize: 15,
    color: "#444",
    lineHeight: 22,
  },

  boldItalic: {
    fontWeight: "700",
    fontStyle: "italic",
  },

  bold: {
    fontWeight: "700",
  },
});